module.exports = __webpack_public_path__ + "img/fig10.d3a43843.jpg";